import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { MenuItem } from "@material-ui/core";
import { traerAfiliaciones } from "../../../../actions/abm/abmAfiliaciones";
import { traerConfiguracionPorCategoria } from "../../../../actions/configuraciones/ConfiguracionCategoria";
import { SelectValidator } from "react-material-ui-form-validator";

export const CboCategoriaWeb = React.memo((props) => {

  const [listaCateg, setListaCat] = useState([]);
  const { items } = useSelector(state => state.categorias);
  const dispatch = useDispatch();
  const afiliaciones = useSelector(state => state.tipoAfiliaciones);


  useEffect(() => {
    if (items?.length > 0) {
      let catFromState = items.map((cat) => {
        return {
          value: cat.id_sr,
          display: cat.descripcion_sr,
        };
      });
      setListaCat(catFromState);
    }
    dispatch(traerAfiliaciones());
  }, [dispatch, items]);

  useEffect(() => {
    if (afiliaciones.items.length > 0) {
    }
  }, [afiliaciones.items])

  const onChange = (e) => {
    dispatch(traerConfiguracionPorCategoria(e.target.value));
  }

  return (
    <>
      <SelectValidator
        fullWidth={true}
        margin="normal"
        value={props.valor}
        name="id_sit_revista"
        onChange={(e) => {
          onChange(e);
          props.manejadorInputChange(e);
        }}
        label="Sit. laboral"
        validators={['required']}
        errorMessages={['Seleccione una opción']}
      >
        <MenuItem value={-1}>
          <em>Seleccione</em>
        </MenuItem>
        {listaCateg.map((cat) => (
          <MenuItem key={cat.value} value={cat.value}>
            {cat.display}
          </MenuItem>
        ))}
      </SelectValidator>
    </>
  );
});
